import { setCurrentStore } from '@state/features/storelocator.slice';
import analytics from '@utils/analytics';
import FocusTrap from 'focus-trap-react';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import StoreAddress from './StoreAddress';
import { autoChooseClassnames, getId } from '@common/utils/brandDiffsUtils';
const COLLECTIONS = ['men', 'women', 'children'];
const COLLECTIONSCODES = ['01', '02', '03'];
const StoreLocatorResults = (props) => {
    const { t } = useTranslation();
    const { filteredStores, close } = props;
    const dispatch = useDispatch();
    const results = useRef();
    const { baseUrl, address } = useSelector((state) => state.storelocator);
    const printCollections = (collections) => {
        const list = collections.split(' ');
        const listnames = list.map((el) => {
            if (COLLECTIONSCODES.indexOf(el) != -1) {
                return t(`storelocator.${COLLECTIONS[COLLECTIONSCODES.indexOf(el)]}`);
            }
            else {
                // fallback
                return el;
            }
        });
        return listnames.join(' ');
    };
    return (React.createElement(FocusTrap, { focusTrapOptions: {
            onDeactivate: close,
            allowOutsideClick: (e) => {
                if (!results.current.contains(e.target)) {
                    const isAnchor = e.target;
                    if (isAnchor === null || isAnchor === void 0 ? void 0 : isAnchor.href) {
                        window.location.href = isAnchor.href;
                    }
                    else {
                        close();
                    }
                }
                return true;
            },
            fallbackFocus: () => {
                return results.current;
            },
        } },
        React.createElement("div", { role: "dialog", "aria-modal": "true", ref: results, className: "search-store__resultslist", id: "resultsOptions", tabIndex: -1, "aria-labelledby": "resultsOptions_title" },
            React.createElement("button", { className: autoChooseClassnames({
                    MO: 'icon--close',
                    ST: 'button__close icon--16-close',
                }), type: "button", "aria-label": t('button.close'), onClick: () => {
                    close();
                } }),
            React.createElement("h2", { className: "visually-hidden", id: "resultsOptions_title" }, t('storelocator.nboutiquesnear', { 0: filteredStores.length, 1: address })),
            getId() === 'ST' && React.createElement("div", { className: "search-store__resultslist__title" }, address),
            React.createElement("ul", null, filteredStores.map((store, i) => (React.createElement("li", { key: i, className: "search-store__resultslist__menuitem" },
                React.createElement("a", { className: "visually-hidden", href: `${baseUrl}/storelocator/${store.slug}`, tabIndex: -1, "aria-hidden": "true" }, store.name),
                React.createElement("h3", { className: "search-store__resultslist__menuitem__name" },
                    React.createElement("button", { onClick: () => {
                            analytics.storelocatorSelect(store.name);
                            props.onItemClick && props.onItemClick();
                            dispatch(setCurrentStore(store.ID));
                        }, "aria-haspopup": "dialog", "aria-label": store.name, onKeyDown: (e) => {
                            if (e.key == 'Escape') {
                                e.preventDefault();
                                close();
                            }
                        } }, store.name)),
                store.storeCollections && getId() === 'MO' && React.createElement("span", { className: "search-store__resultslist__menuitem__collection" }, printCollections(store.storeCollections)),
                React.createElement(StoreAddress, { store: store, hidename: true }),
                store.phone && React.createElement("p", { className: "search-store__resultslist__menuitem__phone" }, store.phone))))))));
};
export default StoreLocatorResults;
